/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spellcheck_Preview_LabelInputs */

const en_spellcheck_preview_label = /** @type {(inputs: Spellcheck_Preview_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preview`)
};

const fr_spellcheck_preview_label = /** @type {(inputs: Spellcheck_Preview_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apercu`)
};

const de_spellcheck_preview_label = /** @type {(inputs: Spellcheck_Preview_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorschau`)
};

const it_spellcheck_preview_label = /** @type {(inputs: Spellcheck_Preview_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anteprima`)
};

const ru_spellcheck_preview_label = /** @type {(inputs: Spellcheck_Preview_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предварительный просмотр`)
};

const es_spellcheck_preview_label = /** @type {(inputs: Spellcheck_Preview_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avance`)
};

const zh_cn2_spellcheck_preview_label = /** @type {(inputs: Spellcheck_Preview_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`预览`)
};

const ja_spellcheck_preview_label = /** @type {(inputs: Spellcheck_Preview_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プレビュー`)
};

const hi_spellcheck_preview_label = /** @type {(inputs: Spellcheck_Preview_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पूर्व दर्शन`)
};

const pt_pt2_spellcheck_preview_label = /** @type {(inputs: Spellcheck_Preview_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pré-visualização`)
};

/**
* | output |
* | --- |
* | "Preview" |
*
* @param {Spellcheck_Preview_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const spellcheck_preview_label = /** @type {((inputs?: Spellcheck_Preview_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spellcheck_Preview_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_spellcheck_preview_label(inputs)
	if (locale === "de") return de_spellcheck_preview_label(inputs)
	if (locale === "it") return it_spellcheck_preview_label(inputs)
	if (locale === "ru") return ru_spellcheck_preview_label(inputs)
	if (locale === "es") return es_spellcheck_preview_label(inputs)
	if (locale === "zh-CN") return zh_cn2_spellcheck_preview_label(inputs)
	if (locale === "ja") return ja_spellcheck_preview_label(inputs)
	if (locale === "hi") return hi_spellcheck_preview_label(inputs)
	if (locale === "pt-PT") return pt_pt2_spellcheck_preview_label(inputs)
	return en_spellcheck_preview_label(inputs)
});